import { render } from "./rightsideView.vue?vue&type=template&id=c50a9438"
import script from "./rightsideView.vue?vue&type=script&lang=js"
export * from "./rightsideView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__